/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/***************************************************************************
 * ========================================================================
 * Copyright 2022 VMware, Inc.  All rights reserved. VMware Confidential
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'geo-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const geoMatchLabel = `${prefix}.geoMatchLabel`;

export const ENGLISH = {
    [geoMatchLabel]: 'Geo Match',
};
